"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/formFill/PageView.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _FilledPage = require('web/components/Forms/FilledPage'); var _FilledPage2 = _interopRequireDefault(_FilledPage);
var _Sheet = require('./Sheet'); var _Sheet2 = _interopRequireDefault(_Sheet);






/* The form's pages with the staff's values and the log's rows drawn in their
 * boxes, as the signed PDF stamps them. */
const PageView = ({ view, onClose }) => {
  const valueOf = (f) => (f.filler === 'staff' ? _optionalChain([view, 'access', _ => _.StaffValues, 'optionalAccess', _2 => _2[f.id]]) || '' : '')
  return (
    _react2.default.createElement(_Sheet2.default, { label: "The form's pages"  , onClose: onClose, full: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
      , _react2.default.createElement('div', { className: "form-fill--sheet-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
        , _react2.default.createElement('div', { className: "form-fill--sheet-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}},  view.FormName )
        , _react2.default.createElement('button', { type: "button", className: "form-fill--link", onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, "Close")
      )
      , _react2.default.createElement('div', { className: "form-fill--pages", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
        ,  (_nullishCoalesce(view.Pages, () => ( []))).map((page, i) => (
          _react2.default.createElement(_FilledPage2.default, {
            key: page.FileKey,
            page: page,
            pageIndex: i,
            fields: _nullishCoalesce(view.Fields, () => ( [])),
            valueOf: valueOf,
            rows: _nullishCoalesce(view.Rows, () => ( [])),
            label: `Page ${i + 1}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
          )
        )) 
      )
    )
  )
}

exports. default = PageView
